import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { 
  Monitor, 
  Smartphone,
  Sun,
  Moon,
  Bell,
  Settings
} from 'lucide-react';

interface ViewToggleProps {
  currentView: 'desktop' | 'mobile';
  onViewChange: (view: 'desktop' | 'mobile') => void;
  isDarkMode?: boolean;
  onThemeToggle?: () => void;
}

export const ViewToggle = ({ 
  currentView, 
  onViewChange,
  isDarkMode = false,
  onThemeToggle
}: ViewToggleProps) => {
  return (
    <div className="flex items-center gap-2 p-2 bg-muted/50 rounded-lg">
      <Button
        variant={currentView === 'desktop' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewChange('desktop')}
        className="gap-2"
      >
        <Monitor className="h-4 w-4" />
        Desktop
      </Button>
      <Button
        variant={currentView === 'mobile' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewChange('mobile')}
        className="gap-2"
      >
        <Smartphone className="h-4 w-4" />
        Mobile
      </Button>
      
      {onThemeToggle && (
        <div className="h-6 w-px bg-border mx-1" />
      )}
      
      {onThemeToggle && (
        <Button
          variant="ghost"
          size="icon"
          onClick={onThemeToggle}
          className="h-8 w-8"
        >
          {isDarkMode ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>
      )}
    </div>
  );
};